import { useLocation, useParams } from 'react-router-dom'
import { Column } from 'src/shared/components/Semantic/all'
import { RequestWorkspace } from 'src/pages/_myAccount/Requests/Request/components/RequestWorkspace'

export const GuidedAssistantPage = () => {
  const { public_id } = useParams<{ public_id: string }>()
  const location = useLocation()
  const chatResetAt = (
    location.state as { chatResetAt?: number } | null
  )?.chatResetAt

  return (
    <Column className="flex h-full min-h-0 flex-col overflow-hidden">
      <RequestWorkspace
        key={chatResetAt ?? public_id}
        publicId={public_id}
        exploreMode
      />
    </Column>
  )
}
